import { fromJS } from 'immutable';

import * as ActionTypes from '../lib/constants/ActionTypes';

export const generalState = fromJS({
  debugging: {
    key: '',
    workflow: '',
    action: '',
    uuid: null,
  },
  errors: [],
  rethrow: false,
});

function setState(state, newState) {
  return state.merge(newState);
}

export default function general(state = generalState, action) {
  switch (action.type) {
    case ActionTypes.CLEAR_ERRORS:
      return setState(state, generalState);

    case ActionTypes.CLEAR_ERROR_MESSAGES:
      return setState(
        state,
        state.set(
          'errors',
          action.payload
            ? state
                .get('errors')
                .filterNot((error) => action.payload.includes(error))
            : generalState.get('errors')
        )
      );

    case ActionTypes.SET_DEBUG:
      return setState(
        state,
        state.setIn(['debugging', action.payload.key], action.payload.value)
      );

    case ActionTypes.SET_ERROR:
      return setState(
        state,
        state.set('errors', state.get('errors').push(action.payload))
      );

    case ActionTypes.ENABLE_RETHROW:
      return setState(state, state.set('rethrow', true));

    case ActionTypes.DISABLE_RETHROW:
      return setState(state, state.set('rethrow', false));

    default:
      return state;
  }
}
